import { Column } from '@syncfusion/ej2-angular-grids';
//import { ReportsService } from './../../../services/report.service';
import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, TemplateRef, ViewChild, ElementRef, model } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ReportsService } from 'src/app/services/report.service';
import * as ExcelJS from 'exceljs';
import { DatePipe } from '@angular/common';
import { GridLine } from '@syncfusion/ej2-grids';
import { GeneralService } from 'src/app/services/general.service';
import { ERentalReports } from 'src/app/Shared/enum';
import { IReportResponse } from 'src/app/Shared/model/ReportsModel';
import { OperationRentalService } from 'src/app/services/Rentals.service';
import { Subscription, take } from 'rxjs';
import { ANGULAR_MODULES, GENERAL_COMPONENTS, Operational_COMPONENTS, SYNCFUSION_MODULES } from 'src/app/Shared/shared-imports';
import { VendorSearchComponent } from 'src/app/Shared/vendor-search/vendor-search.component';
import { WordReplacePipe } from 'src/app/Shared/word-replace.pipe';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { VendorService } from 'src/app/services/Vendor.service';
import Swal from 'sweetalert2';
import { MarketInfoService } from 'src/app/services/marketInfo.service';
import { Boothtypeservice } from 'src/app/services/Boothtypeservice';
import { OtherChargesService } from 'src/app/services/other-charges.service';
import { GridComponent } from '@syncfusion/ej2-angular-grids';
import { LayoutService } from 'src/app/services/layout.service';
import { RenderDayCellEventArgs } from '@syncfusion/ej2-angular-calendars';
import { UserService } from '../../../services/User.service';
import { LoaderComponent } from 'src/app/Shared/loader/loader.component';
import { ComboBoxModule } from '@syncfusion/ej2-angular-dropdowns';
import { PosOpeningCashDrawerService } from 'src/app/services/pos_OpeningCashDrawer.service';
import { WordReplacementService } from 'src/app/services/word-replacement.service';
import { ASLicenseSettings } from 'src/app/Shared/model/GeneralModel';

@Component({
  selector: 'op-shared-reports',
  templateUrl: './op-shared.component.html',
  styleUrls: ['./op-shared.component.scss'],
  standalone: true,
  imports: [Operational_COMPONENTS, ANGULAR_MODULES, GENERAL_COMPONENTS, SYNCFUSION_MODULES, VendorSearchComponent, WordReplacePipe, LoaderComponent,ComboBoxModule]
})
export class OpSharedReportComponent implements OnInit {
  VendorFilterOption = {
    All: true,
    Current: false,
    Inactive: false,
    PageModel: {
      pageCount: 1,
      pageSize: 20
    }
  };
  public today: Date = new Date(new Date().toDateString());
  public weekStart: Date = new Date(new Date(new Date().setDate(new Date().getDate() - (new Date().getDay() + 6) % 7)).toDateString());
  public weekEnd: Date = this.today;
  public monthStart: Date = new Date(new Date(new Date().setDate(1)).toDateString());
  public monthEnd: Date = this.today;
  public yearStart: Date = new Date(new Date().getFullYear(), 0, 1);
  public yearEnd: Date = this.today;
  public nextMonthSameDay: Date = new Date(new Date().getFullYear(), new Date().getMonth() + 1, new Date().getDate());
  public tomorrow: Date = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1);
  public nextmonthNextDay: Date = new Date(new Date().getFullYear(), new Date().getMonth() + 1, new Date().getDate() + 1);
  public datePipe = new DatePipe('en-US');
  public currentDate = this.datePipe.transform(this.today, ' MM/dd/yyyy');
  currentYear = new Date().getFullYear();
  private allColumns: any[] = [];
  public vendorColumns1: any[] = [];
  public selectedColumns1: any[] = [];

  fiscalYearList: { id: number; text: string }[] = [
    {
      id: this.currentYear,
      text: `Jan ${this.currentYear} - Dec ${this.currentYear}`
    }
  ];
  @Output() closeModalEvent = new EventEmitter<boolean>();

  @ViewChild('otherGrid', { static: false }) public othergridData: GridComponent;
  @ViewChild('partGrid', { static: false }) public partgridData: GridComponent;
  @ViewChild('terminalGrid', { static: false }) public terminalgridData: GridComponent;

  @ViewChild('FAselectbutton') FAselectbutton!: ElementRef<HTMLInputElement>;
  @ViewChild('FAclearselectbutton') FAclearselectbutton!: ElementRef<HTMLInputElement>;
  @ViewChild('Terselectbutton') Terselectbutton!: ElementRef<HTMLInputElement>;
  @ViewChild('Terclearselectbutton') Terclearselectbutton!: ElementRef<HTMLInputElement>;
  @ViewChild('gridAvailableColumns1', { static: false }) gridAvailableColumns1: GridComponent;
  @ViewChild('gridSelectedColumns1', { static: false }) gridSelectedColumns1: GridComponent;

  selectedReportName = ''
  selectedReportID: any = 0;
  marketName = "";
  @Input() ReportId: number;
  @Input() ReportName: string;
  selectedDateRange: any[] = [];
  public loaderIcon: Promise<boolean>;
  moduleName = 'ReportsModule';
  reportForm: FormGroup;
  mrktReportForm: FormGroup;
  pipe;
  reportUrl;
  innerModalRef!: NgbModalRef;
  BoothType;
  months = [{ Id: 1, Month: "January" },
  { Id: 2, Month: "February" },
  { Id: 3, Month: "March" },
  { Id: 4, Month: "April" },
  { Id: 5, Month: "May" },
  { Id: 6, Month: "June" },
  { Id: 7, Month: "July" },
  { Id: 8, Month: "August" },
  { Id: 9, Month: "September" },
  { Id: 10, Month: "October" },
  { Id: 11, Month: "November" },
  { Id: 12, Month: "December" }];

  public filterSettings: Object;
  public lines: GridLine;
  toasterConfig = {
    closeButton: true,
    timeOut: 4500,
    easing: 'ease-out',
    progressBar: true,
    positionClass: 'toast-top-right',
    tapToDismiss: true,
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'slideUp',
    maxOpened: 1,
    preventDuplicates: true,
  };
  EPresetValue;
  ERentalReports;
  private subscriptions: Subscription[] = [];
  marketId: any;
  RentaltypeList: string;
  daily = false;
  monthly = false;
  weekly = false;
  combinedMonthly = false;
  combinedWeekly = false;
  quickDaily = false;
  currentMonth = (new Date().getMonth() + 1).toString();
  OtherTypeLists = [];
  revenueCategoriesList = [];
  DisableSelectDate = true;
  parts: any;
  marketDaySettings;
  selectedMarketDays = [];
  monthYearOptions=[];
  userList: any[] = [];
  isBulkSelection = false;
  terminalsLists: any[] = [];
  wordrelacementTerms ={booth: '',vendor: '',market: ''};
  noLayout = false;

  constructor(private formBuilder: FormBuilder,
    private service: ReportsService,
    private generalService: GeneralService,
    private modalService: NgbModal,
    private operationRentalService: OperationRentalService,
    private vendorService: VendorService,
    private marketInfoService: MarketInfoService,
    private boothtypeservice: Boothtypeservice,
    private otherchargesservice: OtherChargesService,
    private layoutService: LayoutService,
    private userService: UserService,
    private posOpeningCashDrawerService: PosOpeningCashDrawerService,
    private wordReplacementService: WordReplacementService,
    private reportsService: ReportsService,
  ) {
  }

  ngOnInit() {
    this.reportForm = this.formBuilder.group({
      StorageFacility: 1
    });

    this.subscriptions.push(this.generalService.getTermsUsedInMarket().subscribe(res => {
      this.wordReplacementService.setTermMap({
        booth: res.BoothTerm,
        vendor: res.VendorTerm,
        market: res.MarketTerm
      });
      this.wordrelacementTerms={booth: res.BoothTerm,
        vendor: res.VendorTerm,
        market: res.MarketTerm};
    }));

    this.ERentalReports = ERentalReports;
    this.subscriptions.push(this.operationRentalService.getDefaultMarketId().subscribe((res: any) => {
      if (res) {
        this.marketId = res;
      }
    }));
    this.mrktReportForm = this.formBuilder.group({
      VendorId: [''],
      marketVendorId: [''],
      vendorSeqId: [''],
      vendorName: [''],
      VendorFilter: ['1'],
      AutoDeductOption: ['1'],
      ReportType: ['1'],
      OrderBy: ['1'],
      BoothType: ['0'],
      BoothCharges: ['0'],
      RequestedMonth: [this.currentMonth],
      BoothTypeId: [null],
      DisplayVendorid: ['0'],
      ExcludeCat: [0],
      ExcludeDesc: [0],
      Display: [1],
      RentalType: ['4'],
      FromDate: new Date(),
      ToDate: new Date(),
      ExcludeQty:[0],
      ExcludeUnit:[0],
      ReceiptFrom: [null],
      ReceiptTo: [null],
      LeaseExpiry:['0'],
      RentalDate: new Date(),
      Openbooths: [0],
      ExcludeBtype: [0],
      ExcludePname: [0],
      ExcludeEndPeriod: [1],
      ExcludeBDue: [0],
      DealerSelect: ['1'],
      revenueCategory: [0],
      BoothFrom: [0],
      BoothTo: [0],
      selectedMonthYear: [''],
      PeriodOrRange: ['0'],
      TJReceiptFrom: [null],
      TJReceiptTo: [null],
      UserId: [0],
      allUsers: ['0'],
      RevenueBreakup: ['1'],
      All: ['0'],
      FiscalYear: [2026],
      IncludeSales: [false],
      Bookings:[0],
      Reservations:[0],
      VendorNotes:[0],
      VDRReportType:['1'],
    });

    this.selectedReportName = this.ReportName;
    this.selectedReportID = this.ReportId;
    this.getReportUrl();
    this.getBoothTypes();
    this.getRentalType();
    this.getRevenueCategories();
    this.getOtherCharges();
    this.getParts();
    this.GetMarketDaysSettings();
    this.getUserList();
    this.getPOSTerminals();
    this.GetVendorColumnDescriptions();
    this.getMarketName();
    this.getASCloudLicenseSettings();
    const startYear = 1900;
    const endYear = 2100;
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];

    for (let year = startYear; year <= endYear; year++) {
    for (let month = 1; month <= 12; month++) {
      this.monthYearOptions.push({
        label: `${months[month - 1]} ${year}`,
        value: `${year}${month.toString().padStart(2, '0')}`
      });
    }
  }
    const current = new Date();
    const currentMonthYear = `${current.getFullYear()}${(current.getMonth() + 1)
      .toString()
      .padStart(2, "0")}`;

    this.mrktReportForm.get("selectedMonthYear")?.setValue(currentMonthYear);


    this.mrktReportForm.get('BoothCharges')?.valueChanges.subscribe(value => {
      if (value === '0') {
        // Clear the dropdown when 'Show All 12 Months' is selected
        this.mrktReportForm.get('RequestedMonth')?.setValue(this.currentMonth);
      }
    });

    this.mrktReportForm.get('BoothType')?.valueChanges.subscribe(value => {
      if (value === '0') {
        // Clear the dropdown when 'Show All 12 Months' is selected
        this.getBoothTypes();
      }
    });

    this.mrktReportForm.get('ReportType')?.valueChanges.subscribe(value => {
       if (value ==='1' || value ==='2') {
        this.mrktReportForm.get('ReceiptFrom')?.setValue(null);
        this.mrktReportForm.get('ReceiptTo')?.setValue(null);
      }
    });

    this.mrktReportForm.get('PeriodOrRange')?.valueChanges.subscribe(value => {
       if (value ==='1') {
        this.mrktReportForm.get('TJReceiptFrom')?.setValue(null);
        this.mrktReportForm.get('TJReceiptTo')?.setValue(null);
      }
    });

    this.subscriptions.push(this.mrktReportForm.get('DisplayVendorid').valueChanges.subscribe(value => {
      this.mrktReportForm.patchValue({ vendorSeqId: '' });
      this.mrktReportForm.patchValue({ marketVendorId: '' });
      this.mrktReportForm.patchValue({ vendorName: '' });

    }))


    this.subscriptions.push(this.mrktReportForm.get('FromDate').valueChanges.subscribe(value => {
      if (this.mrktReportForm.controls['ToDate'].value < this.mrktReportForm.controls['FromDate'].value) {
        this.mrktReportForm.patchValue({
          ToDate: this.mrktReportForm.controls['FromDate'].value
        })
      }
    }))

    this.subscriptions.push(this.mrktReportForm.get('ToDate').valueChanges.subscribe(value => {
      if (this.mrktReportForm.controls['FromDate'].value > this.mrktReportForm.controls['ToDate'].value) {
        this.mrktReportForm.patchValue({
          FromDate: this.mrktReportForm.controls['ToDate'].value
        })
      }
    }))

    if (this.selectedReportID === ERentalReports.DesignVendorReport) {
      this.mrktReportForm.get("FromDate")?.disable();
      this.mrktReportForm.get("ToDate")?.disable();
      this.mrktReportForm
        .get("VDRReportType")
        ?.valueChanges.subscribe((value) => {
          if (value === "2" || value === "4" || value === "7") {
            this.mrktReportForm.get("FromDate")?.enable();
            this.mrktReportForm.get("ToDate")?.enable();
          }
          else{
            this.mrktReportForm.get("FromDate")?.disable();
            this.mrktReportForm.get("ToDate")?.disable();
            this.mrktReportForm.get("FromDate")?.setValue(new Date);
            this.mrktReportForm.get("ToDate")?.setValue(new Date);
          }
        });
    }
    if (this.selectedReportID === ERentalReports.DealerSecDepositLeaseExpiry) {
      this.mrktReportForm.get('ToDate')?.disable();
      this.mrktReportForm.get('FromDate')?.disable();
      this.mrktReportForm.get('LeaseExpiry')?.valueChanges.subscribe(value => {
        if (value == "0") {
          this.mrktReportForm.get('ToDate')?.disable();
          this.mrktReportForm.get('FromDate')?.disable();
        } else {
          this.mrktReportForm.get('ToDate')?.enable();
          this.mrktReportForm.get('FromDate')?.enable();
        }
      });
    }

    if (this.selectedReportID === ERentalReports.TransactionJournal) {
      this.mrktReportForm.get('UserId')?.disable();
      this.mrktReportForm.get('allUsers')?.valueChanges.subscribe(value => {
        if (value == "1") {
          this.mrktReportForm.get('UserId')?.enable();
        } else {
          this.mrktReportForm.get('UserId')?.disable();
        }
      });
    }

    if (this.selectedReportID === ERentalReports.DealerBooths) {
      this.mrktReportForm.get('DisplayVendorid')?.disable();
      this.mrktReportForm.get('BoothFrom')?.disable();
      this.mrktReportForm.get('BoothTo')?.disable();
      this.mrktReportForm.get('revenueCategory')?.disable();
      this.mrktReportForm.get('ReportType')?.valueChanges.subscribe(value => {
        if (value == "1") {
          this.mrktReportForm.get('DisplayVendorid')?.setValue("0");
          this.mrktReportForm.get('DisplayVendorid')?.disable();
          this.mrktReportForm.get('Openbooths')?.enable();
          this.mrktReportForm.get('DealerSelect')?.enable();

        } else {
          this.mrktReportForm.get('DisplayVendorid')?.enable();
          this.mrktReportForm.get('Openbooths')?.setValue(0);
          this.mrktReportForm.get('DealerSelect')?.setValue("1");
          this.mrktReportForm.get('Openbooths')?.disable();
          this.mrktReportForm.get('DealerSelect')?.disable();
          this.mrktReportForm.get('revenueCategory')?.disable();
        }
      });

      this.mrktReportForm.get('DealerSelect')?.valueChanges.subscribe(value => {
        if (value == "1") {
          this.mrktReportForm.get('BoothFrom')?.setValue("0");
          this.mrktReportForm.get('BoothFrom')?.disable();
          this.mrktReportForm.get('BoothTo')?.setValue("0");
          this.mrktReportForm.get('BoothTo')?.disable();
          this.mrktReportForm.get('revenueCategory')?.disable();

        }
        else if (value == "2") {
          this.mrktReportForm.get('BoothFrom')?.setValue("0");
          this.mrktReportForm.get('BoothTo')?.setValue("0");
          this.mrktReportForm.get('BoothFrom')?.enable();
          this.mrktReportForm.get('BoothTo')?.enable();
          this.mrktReportForm.get('revenueCategory')?.disable();

        }
        else if (value == "3") {
          this.mrktReportForm.get('BoothFrom')?.setValue("0");
          this.mrktReportForm.get('BoothTo')?.setValue("0");
          this.mrktReportForm.get('BoothFrom')?.disable();
          this.mrktReportForm.get('BoothTo')?.disable();
          this.mrktReportForm.get('revenueCategory')?.disable();

        }
        else {
          this.mrktReportForm.get('BoothFrom')?.setValue("0");
          this.mrktReportForm.get('BoothTo')?.setValue("0");
          this.mrktReportForm.get('BoothFrom')?.disable();
          this.mrktReportForm.get('BoothTo')?.disable();
          this.mrktReportForm.get('revenueCategory')?.enable();
        }
      });
    }

    if (this.selectedReportID === ERentalReports.BoothsDroppedbyDealer) {
      this.mrktReportForm.get('selectedMonthYear')?.disable();
      this.mrktReportForm.get('FromDate')?.enable();
      this.mrktReportForm.get('ToDate')?.enable();
      this.mrktReportForm.get('ReportType')?.valueChanges.subscribe(value => {
        if (value == "1") {
          this.mrktReportForm.get('selectedMonthYear')?.setValue(currentMonthYear);
          this.mrktReportForm.get('selectedMonthYear')?.disable();
          this.mrktReportForm.get('ToDate')?.enable();
          this.mrktReportForm.get('FromDate')?.enable();

        }
        else {
          this.mrktReportForm.get('selectedMonthYear')?.enable();
          this.mrktReportForm.get('FromDate')?.disable();
          this.mrktReportForm.get('ToDate')?.disable();
          this.mrktReportForm.get('FromDate')?.setValue(new Date());
          this.mrktReportForm.get('ToDate')?.setValue(new Date());
        }
      });
    }

    if (this.selectedReportID === ERentalReports.YTDPayments) {
      const currentYear = 2026;          // start year
      const minYear = 2015;              // change as needed
      this.setupVendorFilterWatcher();
      this.fiscalYearList = this.getFiscalYearList(minYear, currentYear);
      this.mrktReportForm.patchValue({
        OrderBy: "2",
        FiscalYear: currentYear
      });
    }
    if (this.selectedReportID === ERentalReports.VendorListing) {
      this.mrktReportForm.get('marketVendorId')?.disable();
      this.mrktReportForm.get('vendorName')?.disable();
      this.mrktReportForm.get('VendorNotes')?.disable();
      this.mrktReportForm.get('VendorFilter')?.valueChanges.subscribe(value => {
        if (value !== '2') {
          this.mrktReportForm.get('marketVendorId')?.disable();
          this.mrktReportForm.get('vendorName')?.disable();
          this.mrktReportForm.get('marketVendorId')?.setValue('');
          this.mrktReportForm.get('vendorName')?.setValue('');
        } else {
          this.mrktReportForm.get('marketVendorId')?.enable();
          this.mrktReportForm.get('vendorName')?.enable();
        }
      });
      this.mrktReportForm.get('ReportType')?.valueChanges.subscribe(value => {
        if (value !== "2") {
          this.mrktReportForm.get('VendorNotes')?.disable();
          this.mrktReportForm.get('VendorNotes')?.setValue(0);
        } else {
          this.mrktReportForm.get('VendorNotes')?.enable();
        }
      });
    }

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['ReportId'] !== undefined) {
      this.ngOnInit();
    }
  }

  getReportUrl() {
    this.generalService.getReportUrl().subscribe((response: any) => {
      this.reportUrl = response;
    });
  }

  closeModal() {
    this.closeModalEvent.next(true);
  }

  invokeReport(obj) {
    var openInNewTab = '_blank';
    this.loaderIcon = Promise.resolve(true);
    this.service.generateReport(obj).subscribe((response: IReportResponse) => {
      if (response.Success) {
        window.open(this.reportUrl + `report?id=` + response.ReportRequestId,
          openInNewTab, 'width=' + (screen.availWidth - 5) + ',height=' + (screen.availHeight - 5));
        this.loaderIcon = Promise.resolve(false);
      } else {
        console.log('Error on generating Operational Report');
        this.loaderIcon = Promise.resolve(false);
      }
    });
  }

  onReportView(Button) {
    if (this.selectedReportID === ERentalReports.OutstandingBalances) {
      var obj;
      obj = {
        ReportName: "OutstandingBalancesReport",
        ReportParameters: {},
        MarketId: this.marketId
      };
      obj.ReportParameters["OrderBy"] = this.mrktReportForm.controls['OrderBy'].value;
      obj.ReportParameters["ReportType"] = this.mrktReportForm.controls['ReportType'].value;
      obj.ReportParameters["MarketId"] = this.marketId;
      if (this.mrktReportForm.controls['DisplayVendorid'].value === '1') {
        obj.ReportParameters["VendorID"] = this.mrktReportForm.controls['vendorSeqId'].value;
        if (!obj.ReportParameters["VendorID"]) {
          Swal.fire({
            title: $localize`Warning`,
            text: $localize`Please enter the Vendor ID`,
            icon: "warning",
            confirmButtonText: $localize`Ok`,
          });

          this.loaderIcon = Promise.resolve(false);
          return false

        }
      }
      else {
        obj.ReportParameters["VendorID"] = 0;
      }

    }
    if (this.selectedReportID === ERentalReports.BoothPriceListing) {
      var obj;
      obj = {
        ReportName: "BoothPriceListing",
        ReportParameters: {},
        MarketId: this.marketId
      };

      obj.ReportParameters["Charges"] = this.mrktReportForm.controls['BoothCharges'].value;
      obj.ReportParameters["MarketId"] = this.marketId;
      obj.ReportParameters["OrderBy"] = this.mrktReportForm.controls['OrderBy'].value;
      obj.ReportParameters["ExcludeCat"] = this.mrktReportForm.controls['ExcludeCat'].value;
      obj.ReportParameters["ExcludeDesc"] = this.mrktReportForm.controls['ExcludeDesc'].value;
      obj.ReportParameters["RentalType"] = this.mrktReportForm.controls['RentalType'].value;
      obj.ReportParameters["Display"] = this.mrktReportForm.controls['Display'].value;
      obj.ReportParameters["RequestedMonth"] = this.mrktReportForm.controls['RequestedMonth'].value;
      obj.ReportParameters["BTerm"] = this.wordrelacementTerms.booth!=''?this.wordrelacementTerms.booth:'Booth';
      obj.ReportParameters["NoLayout"] = this.noLayout;

      if (this.mrktReportForm.controls["BoothType"].value == 1) {
        obj.ReportParameters["BoothTypes"] = this.mrktReportForm.controls['BoothTypeId'].value;
        if ((obj.ReportParameters["BoothTypes"]==null)) {
          Swal.fire({
            title: $localize`Warning`,
            text: $localize`Please select a Booth Type`,
            icon: "warning",
            confirmButtonText: $localize`Ok`,
          });

          this.loaderIcon = Promise.resolve(false);
          return false

        }
      }
      else {
        obj.ReportParameters["BoothTypes"] = this.mrktReportForm.controls['BoothType'].value;
      }
    }

    if (this.selectedReportID === ERentalReports.FinancialAudit) {
      var obj;
      obj = {
        ReportName: "FinancialAuditReport",
        ReportParameters: {},
        MarketId: this.marketId
      };
      obj.ReportParameters["OrderBy"] = this.mrktReportForm.controls['OrderBy'].value;
      obj.ReportParameters["ReportType"] = this.mrktReportForm.controls['ReportType'].value;

      obj.ReportParameters["FromDate"] = this.datePipe.transform(this.mrktReportForm.controls['FromDate'].value, 'yyyy-MM-dd');
      obj.ReportParameters["ToDate"] = this.datePipe.transform(this.mrktReportForm.controls['ToDate'].value, 'yyyy-MM-dd');
      obj.ReportParameters["ExcludeUnit"] = this.mrktReportForm.controls['ExcludeUnit'].value;
      obj.ReportParameters["ExcludeQty"] = this.mrktReportForm.controls['ExcludeQty'].value;
      obj.ReportParameters["MarketId"] = this.marketId;
      if (this.mrktReportForm.controls['DisplayVendorid'].value === '1') {
        obj.ReportParameters["VendorID"] = this.mrktReportForm.controls['vendorSeqId'].value;
        if (!obj.ReportParameters["VendorID"]) {
          Swal.fire({
            title: $localize`Warning`,
            text: $localize`Please enter the Vendor ID`,
            icon: "warning",
            confirmButtonText: $localize`Ok`,
          });

          this.loaderIcon = Promise.resolve(false);
          return false

        }
      }
      else {
        obj.ReportParameters["VendorID"] = 0;
      }

      obj.ReportParameters["OtherItemList"] = (this.othergridData.getSelectedRecords().map(record => record['OtherRentalChargeId'])).join(', ');

        if(obj.ReportParameters["OtherItemList"] === "" || obj.ReportParameters["OtherItemList"] === null || obj.ReportParameters["OtherItemList"] === undefined
          || obj.ReportParameters["OtherItemList"].length <= 0
        )
          {
            Swal.fire({
              title: $localize`Warning`,
              text: $localize`Please select other item`,
              icon: "warning",
              confirmButtonText: $localize`Ok`,
            });
            this.loaderIcon = Promise.resolve(false);
            return false

          }
      obj.ReportParameters["ReceiptFrom"] = Number(this.mrktReportForm.controls['ReceiptFrom'].value);
      obj.ReportParameters["ReceiptTo"] = Number(this.mrktReportForm.controls['ReceiptTo'].value);
        if (this.mrktReportForm.controls['ReportType'].value == '3') {
          const fromVal = this.mrktReportForm.controls['ReceiptFrom'].value;
          const toVal = this.mrktReportForm.controls['ReceiptTo'].value;

          /* 1️⃣ Check if both are valid numbers */
          if (fromVal !== null && toVal !== null &&
            (isNaN(fromVal) || isNaN(toVal))) {

            Swal.fire({
              title: $localize`Warning`,
              text: $localize`From and To values must be numeric`,
              icon: 'warning',
              confirmButtonText: $localize`Ok`,
            });

            this.loaderIcon = Promise.resolve(false);
            return false;
          }


        else if(fromVal == null || toVal == null){
          Swal.fire({
            title: $localize`Warning`,
            text: $localize`Please enter receipt range`,
            icon: "warning",
            confirmButtonText: $localize`Ok`,
          });

          this.loaderIcon = Promise.resolve(false);
          return false
        }

        else if(fromVal>toVal){
          Swal.fire({
            title: $localize`Warning`,
            text: $localize`To Number can not be less than from number`,
            icon: "warning",
            confirmButtonText: $localize`Ok`,
          });

          this.loaderIcon = Promise.resolve(false);
          return false
        }

      }
      }

    if (this.selectedReportID === ERentalReports.DealerSecDepositLeaseExpiry) {
      var obj;
      obj = {
        ReportName: "DealerSecDepositLeaseExpiry",
        ReportParameters: {},
        MarketId: this.marketId
      };
      obj.ReportParameters["MaketId"] = this.marketId;

      obj.ReportParameters["FromDate"] = this.datePipe.transform(this.mrktReportForm.controls['FromDate'].value, 'yyyy-MM-dd');
      obj.ReportParameters["ToDate"] = this.datePipe.transform(this.mrktReportForm.controls['ToDate'].value, 'yyyy-MM-dd');
      obj.ReportParameters["ReportType"] = this.mrktReportForm.controls['ReportType'].value;
      obj.ReportParameters["LeaseExpiry"] = this.mrktReportForm.controls['LeaseExpiry'].value;
      obj.ReportParameters["Orderby"] = this.mrktReportForm.controls['OrderBy'].value;
      obj.ReportParameters["VTerm"] = this.wordrelacementTerms.vendor!=''?this.wordrelacementTerms.vendor:'Vendor';
    }
    this.loaderIcon = Promise.resolve(false);

    if (this.selectedReportID === ERentalReports.VendorWithAutoDeductRent) {
      var obj;
      obj = {
        ReportName: "VendorWithAutoDeductRentReport",
        ReportParameters: {},
        MarketId: this.marketId
      };

      obj.ReportParameters["OrderBy"] = this.mrktReportForm.controls['OrderBy'].value;
      obj.ReportParameters["VendorFilter"] = this.mrktReportForm.controls['VendorFilter'].value;
      obj.ReportParameters["AutoDeductOption"] = this.mrktReportForm.controls['AutoDeductOption'].value;
      obj.ReportParameters["MarketId"] = this.marketId;

      if (this.mrktReportForm.controls['VendorFilter'].value === '2') {
        obj.ReportParameters["VendorID"] = this.mrktReportForm.controls['vendorSeqId'].value;
        if (!obj.ReportParameters["VendorID"]) {
          Swal.fire({
            title: $localize`Warning`,
            text: $localize`Please enter the Vendor ID`,
            icon: "warning",
            confirmButtonText: $localize`Ok`,
          });
          this.loaderIcon = Promise.resolve(false);
          return false;
        }
      } else {
        obj.ReportParameters["VendorID"] = 0;
      }
    }

    if (this.selectedReportID === ERentalReports.DealerBooths) {
      var obj;
      obj = {
        ReportName: "DealerBoothsReport",
        ReportParameters: {},
        MarketId: this.marketId
      };
      obj.ReportParameters["OrderBy"] = this.mrktReportForm.controls['OrderBy'].value;
      obj.ReportParameters["ReportType"] = this.mrktReportForm.controls['ReportType'].value;
      obj.ReportParameters["RentalDate"] = this.datePipe.transform(this.mrktReportForm.controls['RentalDate'].value, 'yyyy-MM-dd');
      obj.ReportParameters["MarketId"] = this.marketId;
      obj.ReportParameters["ExcludeBtype"] = this.mrktReportForm.controls['ExcludeBtype'].value;
      obj.ReportParameters["ExcludePname"] = this.mrktReportForm.controls['ExcludePname'].value;
      obj.ReportParameters["ExcludeDesc"] = this.mrktReportForm.controls['ExcludeDesc'].value;
      obj.ReportParameters["ExcludeEndPeriod"] = this.mrktReportForm.controls['ExcludeEndPeriod'].value;
      obj.ReportParameters["ExcludeBDue"] = this.mrktReportForm.controls['ExcludeBDue'].value;
      obj.ReportParameters["Openbooths"] = this.mrktReportForm.controls['Openbooths'].value;
      obj.ReportParameters["VTerm"] = this.wordrelacementTerms.vendor!=''?this.wordrelacementTerms.vendor:'Vendor';
      obj.ReportParameters["BTerm"] = this.wordrelacementTerms.booth!=''?this.wordrelacementTerms.booth:'Booth';
      obj.ReportParameters["NoLayout"] = this.noLayout;
      if (this.mrktReportForm.controls['DisplayVendorid'].value === '1') {
        obj.ReportParameters["VendorID"] = this.mrktReportForm.controls['vendorSeqId'].value;
        if (!obj.ReportParameters["VendorID"]) {
          Swal.fire({
            title: $localize`Warning`,
            text: $localize`Please enter the Vendor ID`,
            icon: "warning",
            confirmButtonText: $localize`Ok`,
          });

          this.loaderIcon = Promise.resolve(false);
          return false

        }
      }
      else {
        obj.ReportParameters["VendorID"] = 0;
      }

      if (this.mrktReportForm.controls['DealerSelect'].value == "2") {
        obj.ReportParameters["PartsList"] = '';
        obj.ReportParameters["revenueCategory"] = 0;
        obj.ReportParameters["BoothsFrom"] = this.mrktReportForm.controls['BoothFrom'].value;
        obj.ReportParameters["BoothsTo"] = this.mrktReportForm.controls['BoothTo'].value;


        if (this.mrktReportForm.controls['BoothFrom'].value == 0 || this.mrktReportForm.controls['BoothTo'].value == 0) {
          Swal.fire({
            title: $localize`Warning`,
            text: $localize`Please enter valid booth number`,
            icon: "warning",
            confirmButtonText: $localize`Ok`,
          });

          this.loaderIcon = Promise.resolve(false);
          return false;
        }
      }
      else if (this.mrktReportForm.controls['DealerSelect'].value == "3") {
        obj.ReportParameters["PartsList"] = (this.partgridData.getSelectedRecords().map(record => record['PartId'])).join(', ');
        obj.ReportParameters["revenueCategory"] = 0;
        obj.ReportParameters["BoothsFrom"] = 0;
        obj.ReportParameters["BoothsTo"] = 0;
        if (obj.ReportParameters["PartsList"] == "") {
          Swal.fire({
            title: $localize`Warning`,
            text: $localize`Please select parts`,
            icon: "warning",
            confirmButtonText: $localize`Ok`,
          });

          this.loaderIcon = Promise.resolve(false);
          return false

        }
      }
      else if (this.mrktReportForm.controls['DealerSelect'].value == "4") {
        obj.ReportParameters["PartsList"] = '';
        obj.ReportParameters["revenueCategory"] = this.mrktReportForm.controls['revenueCategory'].value;
        obj.ReportParameters["BoothsFrom"] = 0;
        obj.ReportParameters["BoothsTo"] = 0;
      }
      else {
        obj.ReportParameters["PartsList"] = '';
        obj.ReportParameters["revenueCategory"] = 0;
        obj.ReportParameters["BoothsFrom"] = 0;
        obj.ReportParameters["BoothsTo"] = 0;
      }
    }

    if (this.selectedReportID === ERentalReports.BoothsDroppedbyDealer) {
      var obj;
      obj = {
        ReportName: "BoothsDroppedbyDealer",
        ReportParameters: {},
        MarketId: this.marketId
      };
      obj.ReportParameters["MaketId"] = this.marketId;

      obj.ReportParameters["FromDate"] = this.datePipe.transform(this.mrktReportForm.controls['FromDate'].value, 'yyyy-MM-dd');
      obj.ReportParameters["ToDate"] = this.datePipe.transform(this.mrktReportForm.controls['ToDate'].value, 'yyyy-MM-dd');
      obj.ReportParameters["ReportType"] = this.mrktReportForm.controls['ReportType'].value;
      obj.ReportParameters["selectedMonthYear"] = this.mrktReportForm.controls['selectedMonthYear'].value;
      obj.ReportParameters["Orderby"] = this.mrktReportForm.controls['OrderBy'].value;
      obj.ReportParameters["BTerm"] = this.wordrelacementTerms.booth!=''?this.wordrelacementTerms.booth:'Booth';
      obj.ReportParameters["VTerm"] = this.wordrelacementTerms.vendor!=''?this.wordrelacementTerms.vendor:'Vendor';


    }

    if (this.selectedReportID === ERentalReports.TransactionJournal) {
      var obj;
      if (this.mrktReportForm.controls['ReportType'].value == '1') {
        obj = {
          ReportName: "TransactionJournal",
          ReportParameters: {},
          MarketId: this.marketId
        };
      }
      else if (this.mrktReportForm.controls['ReportType'].value == '2' && this.mrktReportForm.controls['PeriodOrRange'].value == '1') {
        obj = {
          ReportName: "TransactionJournalDetailReceipts",
          ReportParameters: {},
          MarketId: this.marketId
        };
      }
      else {
        obj = {
          ReportName: "TransactionJournalDetail",
          ReportParameters: {},
          MarketId: this.marketId
        };
      }
      obj.ReportParameters["MarketId"] = this.marketId;
      obj.ReportParameters["FromDate"] = this.datePipe.transform(this.mrktReportForm.controls['FromDate'].value, 'MM/dd/yyyy');
      obj.ReportParameters["ToDate"] = this.datePipe.transform(this.mrktReportForm.controls['ToDate'].value, 'MM/dd/yyyy');
      obj.ReportParameters["ReportType"] = this.mrktReportForm.controls['ReportType'].value;
      obj.ReportParameters["PeriodOrRange"] = this.mrktReportForm.controls['PeriodOrRange'].value;
      obj.ReportParameters["orderby"] = this.mrktReportForm.controls['OrderBy'].value;
      obj.ReportParameters["TJReceiptFrom"] = Number(this.mrktReportForm.controls['TJReceiptFrom'].value);
      obj.ReportParameters["TJReceiptTo"] = Number(this.mrktReportForm.controls['TJReceiptTo'].value);
      obj.ReportParameters["RevenueBreakup"] = Number(this.mrktReportForm.controls['RevenueBreakup'].value);

      if(this.mrktReportForm.controls['PeriodOrRange'].value == '1'){
        obj.ReportParameters["Terminallist"] = (this.terminalgridData.getSelectedRecords().map(record => record['Name'])).join(', ');

        if(obj.ReportParameters["Terminallist"] === "" || obj.ReportParameters["Terminallist"] === null || obj.ReportParameters["Terminallist"] === undefined
          || obj.ReportParameters["Terminallist"].length <= 0
        )
          {
            Swal.fire({
              title: $localize`Warning`,
              text: $localize`Please select atleast one PC`,
              icon: "warning",
              confirmButtonText: $localize`Ok`,
            });
            this.loaderIcon = Promise.resolve(false);
            return false

          }
        }
        else{
          obj.ReportParameters["Terminallist"]='';
        }

      if (this.mrktReportForm.controls['allUsers'].value === '1') {
        obj.ReportParameters["UserId"] = this.mrktReportForm.controls['UserId'].value;
        if (!obj.ReportParameters["UserId"]) {
          Swal.fire({
            title: $localize`Warning`,
            text: $localize`Please select a User`,
            icon: "warning",
            confirmButtonText: $localize`Ok`,
          });

          this.loaderIcon = Promise.resolve(false);
          return false

        }
      }
      else {
        obj.ReportParameters["UserId"] = 0;
      }
      if (this.mrktReportForm.controls['DisplayVendorid'].value === '1') {
        obj.ReportParameters["VendorId"] = this.mrktReportForm.controls['vendorSeqId'].value;
        if (!obj.ReportParameters["VendorId"]) {
          Swal.fire({
            title: $localize`Warning`,
            text: $localize`Please enter the Vendor ID`,
            icon: "warning",
            confirmButtonText: $localize`Ok`,
          });

          this.loaderIcon = Promise.resolve(false);
          return false

        }
      }
      else {
        obj.ReportParameters["VendorId"] = 0;
      }
      if(this.mrktReportForm.controls['PeriodOrRange'].value == '1'){

        const fromVal = this.mrktReportForm.controls['TJReceiptFrom'].value;
          const toVal = this.mrktReportForm.controls['TJReceiptTo'].value;

          /* 1️⃣ Check if both are valid numbers */
          if (fromVal !== null && toVal !== null &&
            (isNaN(fromVal) || isNaN(toVal))) {

            Swal.fire({
              title: $localize`Warning`,
              text: $localize`From and To values must be numeric`,
              icon: 'warning',
              confirmButtonText: $localize`Ok`,
            });

            this.loaderIcon = Promise.resolve(false);
            return false;
          }
        if(fromVal == null || toVal == null){
          Swal.fire({
            title: $localize`Warning`,
            text: $localize`Please enter receipt range`,
            icon: "warning",
            confirmButtonText: $localize`Ok`,
          });

          this.loaderIcon = Promise.resolve(false);
          return false
        }

        else if(fromVal>toVal){
          Swal.fire({
            title: $localize`Warning`,
            text: $localize`To Number can not be less than from number`,
            icon: "warning",
            confirmButtonText: $localize`Ok`,
          });

          this.loaderIcon = Promise.resolve(false);
          return false
        }
      }

    }

    if (this.selectedReportID === ERentalReports.AvailableBooths) {
      var obj;
      obj = {
        ReportName: "AvailableBoothsReport",
        ReportParameters: {},
        MarketId: this.marketId
      };
      obj.ReportParameters["MarketId"] = this.marketId;
      obj.ReportParameters["RentalDate"] = this.datePipe.transform(this.mrktReportForm.controls['RentalDate'].value, 'yyyy-MM-dd');
      obj.ReportParameters["BTerm"] = this.wordrelacementTerms.booth!=''?this.wordrelacementTerms.booth:'Booth';
      if (this.mrktReportForm.controls['All'].value == "1") {
        obj.ReportParameters["PartsList"] = (this.partgridData.getSelectedRecords().map(record => record['PartId'])).join(', ');
        if (obj.ReportParameters["PartsList"] == "") {
          Swal.fire({
            title: $localize`Warning`,
            text: $localize`Please select parts`,
            icon: "warning",
            confirmButtonText: $localize`Ok`,
          });

          this.loaderIcon = Promise.resolve(false);
          return false

        }
      }
      else {
        obj.ReportParameters["PartsList"] = '';
      }
    }

    if (this.selectedReportID === ERentalReports.YTDPayments) {
      var obj;
      obj = {
        ReportName: "YTDSalesAndPayments",
        ReportParameters: {},
        MarketId: this.marketId
      };
      obj.ReportParameters["MarketId"] = this.marketId;
      obj.ReportParameters["FiscalYear"] = Number(this.mrktReportForm.controls['FiscalYear'].value);
      obj.ReportParameters["OrderBy"] = Number(this.mrktReportForm.controls['OrderBy'].value);
      const vendorFilter = Number(this.mrktReportForm.controls['DisplayVendorid'].value);
      const vendorSeqId = Number(this.mrktReportForm.controls['vendorSeqId'].value);
      obj.ReportParameters["AllVendors"] = vendorFilter === 1 ? 0 : 1;
      obj.ReportParameters["RequestedVendorId"] = vendorFilter === 1 ? (vendorSeqId || 0) : 0;
      obj.ReportParameters["IncludeSales"] = this.mrktReportForm.value.IncludeSales ? 1 : 0;
      //console.log('YTDPayments ReportParameters:', obj.ReportParameters);
    }

    if (this.selectedReportID === ERentalReports.VendorListing) {
      var obj;
      obj = {
        ReportName: "VendorListingReport",
        ReportParameters: {},
        MarketId: this.marketId
      };

      obj.ReportParameters["OrderBy"] = this.mrktReportForm.controls['OrderBy'].value;
      obj.ReportParameters["FilterVendor"] = this.mrktReportForm.controls['VendorFilter'].value;
      obj.ReportParameters["ReportType"] = this.mrktReportForm.controls['ReportType'].value;
      obj.ReportParameters["MarketId"] = this.marketId;
      obj.ReportParameters["Bookings"] = this.mrktReportForm.controls['Bookings'].value;
      obj.ReportParameters["Reservations"] = this.mrktReportForm.controls['Reservations'].value;
      obj.ReportParameters["ReportType"] = this.mrktReportForm.controls['ReportType'].value;
      obj.ReportParameters["VendorNotes"] = this.mrktReportForm.controls['VendorNotes'].value;
      obj.ReportParameters["BTerm"] = this.wordrelacementTerms.booth!=''?this.wordrelacementTerms.booth:'Booth';
      obj.ReportParameters["VTerm"] = this.wordrelacementTerms.vendor!=''?this.wordrelacementTerms.vendor:'Vendor';

      if (this.mrktReportForm.controls['VendorFilter'].value === '2') {
        obj.ReportParameters["VendorID"] = this.mrktReportForm.controls['vendorSeqId'].value;
        if (!obj.ReportParameters["VendorID"]) {
          Swal.fire({
            title: $localize`Warning`,
            text: $localize`Please enter the Vendor ID`,
            icon: "warning",
            confirmButtonText: $localize`Ok`,
          });
          this.loaderIcon = Promise.resolve(false);
          return false;
        }
      } else {
        obj.ReportParameters["VendorID"] = 0;
      }
    }

    if (this.selectedReportID === ERentalReports.DesignVendorReport) {
      var obj;
      obj = {
        ReportName: "DesignVendorReport",
        ReportParameters: {},
        MarketId: this.marketId
      };

      obj.ReportParameters["OrderBy"] = this.mrktReportForm.controls['OrderBy'].value;
      //obj.ReportParameters["Columns"] = this.selectedColumns1.map(column => column.VdrTxtVendorColumnDesc).join(',');
      const vTerm = this.wordrelacementTerms.vendor != '' ? this.wordrelacementTerms.vendor : 'Vendor';
      const bTerm = this.wordrelacementTerms.booth != '' ? this.wordrelacementTerms.booth : 'Booth';
      function capitalizeFirstLetter(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
      }

      obj.ReportParameters["Columns"] = this.selectedColumns1
        .map((column) =>
          capitalizeFirstLetter(
            column.VdrTxtVendorColumnDesc.replace(/\bVendor\b/g, vTerm).replace(
              /\bBooth\b/g,
              bTerm,
            ),
          ),
        )
        .join(",");

      obj.ReportParameters["VendorTerm"] = this.wordrelacementTerms.vendor!=''?this.wordrelacementTerms.vendor:'Vendor';
      obj.ReportParameters["BoothTerm"] = this.wordrelacementTerms.booth!=''?this.wordrelacementTerms.booth:'Booth';
      obj.ReportParameters["ReportType"] = this.mrktReportForm.controls['VDRReportType'].value;
      obj.ReportParameters["MarketId"] = this.marketId;

      obj.ReportParameters["FromDate"] = this.datePipe.transform(this.mrktReportForm.controls['FromDate'].value, 'yyyy-MM-dd');
      obj.ReportParameters["ToDate"] = this.datePipe.transform(this.mrktReportForm.controls['ToDate'].value, 'yyyy-MM-dd');

      var flag=false;
        var message = "";
        if (this.selectedColumns1.length == 0){
          message = "Please select the fields required"
          flag=true;
        }
        else if(this.selectedColumns1.length > 6){
          message = "Report Can be generated with maximum 6 columns..."
          flag=true;
        }
        else if(this.selectedColumns1.length < 6){
          message = "Please select atleast 6 columns..."
          flag=true;
        }
        if(flag){
          Swal.fire({
            title: $localize`Info`,
            text: message,
            icon: "info",
            confirmButtonText: $localize`Ok`,
          });
          this.loaderIcon = Promise.resolve(false);
          return;
        }
    }

     if (this.selectedReportID === ERentalReports.RentalRevenueandPayment) {
      var obj;
      obj = {
        ReportName: "RentalRevenueandPayment",
        ReportParameters: {},
        MarketId: this.marketId
      };

      obj.ReportParameters["MarketId"] = this.marketId;
      obj.ReportParameters["OrderBy"] = this.mrktReportForm.controls['OrderBy'].value;
      obj.ReportParameters["RequestedMonth"] = this.mrktReportForm.controls['selectedMonthYear'].value;
      obj.ReportParameters["VTerm"] = this.wordrelacementTerms.vendor!=''?this.wordrelacementTerms.vendor:'Vendor';
      obj.ReportParameters["BTerm"] = this.wordrelacementTerms.booth!=''?this.wordrelacementTerms.booth:'Booth';
      if (this.mrktReportForm.controls['DisplayVendorid'].value === '1') {
        obj.ReportParameters["VendorId"] = this.mrktReportForm.controls['vendorSeqId'].value;
        if (!obj.ReportParameters["VendorId"]) {
          Swal.fire({
            title: $localize`Warning`,
            text: $localize`Please enter the Vendor ID`,
            icon: "warning",
            confirmButtonText: $localize`Ok`,
          });

          this.loaderIcon = Promise.resolve(false);
          return false

        }
      }
      else {
        obj.ReportParameters["VendorId"] = 0;
      }
    }

    this.loaderIcon = Promise.resolve(false);
    this.invokeReport(obj)
  }

  async exportToExcel(redirect: boolean) {
    this.loaderIcon = Promise.resolve(true);
     if (this.selectedReportID === ERentalReports.DesignVendorReport) {
      var obj;
      obj = {
        ReportParameters: {},
      };
      var ReportHeader = "";
      obj.ReportParameters["MarketId"] = this.marketId;
      obj.ReportParameters["Date"] = this.datePipe.transform(new Date(), 'MM/dd/yyyy');

        var flag = false;
        var message = "";
        if (this.selectedColumns1.length == 0) {
          message = "Please select the fields required"
          flag = true;
        }
        else if (this.selectedColumns1.length > 6) {
          message = "Report Can be generated with maximum 6 columns..."
          flag = true;
        }
        if (flag) {
          Swal.fire({
            title: $localize`Info`,
            text: message,
            icon: "info",
            confirmButtonText: $localize`Ok`,
          });
          this.loaderIcon = Promise.resolve(false);
          return;
        }
        if (this.mrktReportForm.get('ReportType').value == 1) {
          ReportHeader = "All Rental Active Vendors";
        }
        else if (this.mrktReportForm.get('ReportType').value == 3) {
          ReportHeader = "All Rental Inactive Vendors";
        }
        else if (this.mrktReportForm.get('ReportType').value == 2) {
          // obj.ReportParameters["FromDate"] = this.datePipe.transform(this.mrktReportForm.get('FromDate').value, 'MM/dd/yyyy');
          // obj.ReportParameters["ToDate"] = this.datePipe.transform(this.mrktReportForm.get('ToDate').value, 'MM/dd/yyyy');
          ReportHeader = "Vendor Report"
        }
        else if (this.mrktReportForm.get('ReportType').value == 4) {
          ReportHeader = "Vendor with No Sale" ;
        }
        else if (this.mrktReportForm.get('ReportType').value == 5) {
          ReportHeader = "Vendors with Outstanding Balance" ;
        }
        else if (this.mrktReportForm.get('ReportType').value == 6) {
          ReportHeader = " Currently Web Inquiry Enabled Vendors "
        }
        else if (this.mrktReportForm.get('ReportType').value == 7) {
          ReportHeader = "Vendors with Current Bookings";
        } else if (this.mrktReportForm.get('ReportType').value == 8) {
          ReportHeader = " Currently Web Inquiry Not Enabled Vendors";
        }

        obj.ReportParameters["OrderBy"] = this.mrktReportForm.get('OrderBy').value;
        obj.ReportParameters["FromDate"] = this.mrktReportForm.get('FromDate').value;
        obj.ReportParameters["ToDate"] = this.mrktReportForm.get('ToDate').value;
        obj.ReportParameters["ReportType"] = this.mrktReportForm.get('ReportType').value;
        obj.ReportParameters["Columns"] = this.selectedColumns1.map(column => column.VdrTxtVendorColumnDesc).join(',');

      obj.ReportParameters["ReportHeader"] = ReportHeader;
      const data = await this.service.GetDesignVendorReportsData(obj.ReportParameters).toPromise();
      if (data.length === 0) {
        Swal.fire({
          title: $localize`Info`,
          text: $localize`No Vendor Exists using above selected criteria...`,
          icon: "info",
          confirmButtonText: $localize`Ok`,
        });
        this.loaderIcon = Promise.resolve(false);
        return;
      }

      const marketName = this.marketName
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Vendor Report');
      const csvColumnNames = obj.ReportParameters["Columns"];

      let columnNamesArray = csvColumnNames.split(",").map(name => name.trim());

      const marketRow = worksheet.addRow([marketName]);
      marketRow.getCell(1).alignment = { horizontal: 'center' };
      marketRow.getCell(1).font = { bold: true, size: 16 };
      worksheet.mergeCells(marketRow.number, 1, marketRow.number, columnNamesArray.length);

      const vendorReportRow = worksheet.addRow(["Vendor Report"]);
      vendorReportRow.getCell(1).alignment = { horizontal: 'center' };
      vendorReportRow.getCell(1).font = { bold: false, size: 14 };
      worksheet.mergeCells(vendorReportRow.number, 1, vendorReportRow.number, columnNamesArray.length);

      const reportHeaderRow = worksheet.addRow([obj.ReportParameters["ReportHeader"]]);
      reportHeaderRow.getCell(1).alignment = { horizontal: 'center' };
      reportHeaderRow.getCell(1).font = { bold: false, size: 12 };
      worksheet.mergeCells(reportHeaderRow.number, 1, reportHeaderRow.number, columnNamesArray.length);

     // worksheet.mergeCells(marketRow.number, 1, marketRow.number, columnNamesArray.length);
      const headerRow = worksheet.addRow(columnNamesArray);

      headerRow.eachCell((cell, colNumber) => {
        cell.font = { bold: true };
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'D3D3D3' }
        };
      });

      data.forEach(vendor => {
        const row = [
          vendor["StrColumn1"],
          vendor["StrColumn2"],
          vendor["StrColumn3"],
          vendor["StrColumn4"],
          vendor["StrColumn5"],
          vendor["StrColumn6"]
        ];
        worksheet.addRow(row);
      });

      worksheet.columns.forEach(column => {
        let maxLength = 0;
        column.eachCell({ includeEmpty: true }, (cell) => {
          const cellValue = cell.value ? cell.value.toString() : '';
          maxLength = Math.max(maxLength, cellValue.length);
        });
        column.width = maxLength + 2;
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'VendorReport.xlsx';
      link.click();

    }
    this.loaderIcon = Promise.resolve(false);
  }
  onVendorSelected(vendor: any) {
    this.mrktReportForm.patchValue({
      marketVendorId: vendor.marketVendorId,
      vendorSeqId: vendor.vendorId,
      vendorName: vendor.vendorName
    });
    this.hideVendorSearch();
  }

  getMarketName(): void {
    this.marketInfoService.getMarketName().pipe(take(1)).subscribe({
      next: (res) => {
        this.marketName = res;
      }
    })
  }

  hideVendorSearch() {
    this.innerModalRef?.close();
  }

  OpenVendorSearch(template: TemplateRef<any>) {
    this.innerModalRef = this.modalService.open(template, {
      size: 'lg',
      centered: true,
      backdrop: 'static',
      keyboard: false,
      windowClass: 'nested-modal'  // Optional: Add a custom CSS class for styling
    });

    this.innerModalRef.result.then(
      result => console.log('Inner modal closed with:', result),
      reason => console.log('Inner modal dismissed with:', reason)
    );
  }

  getBoothTypes() {
    this.loaderIcon = Promise.resolve(true);
    const BoothTypeList = this.boothtypeservice.GetAllBoothTypes().subscribe((res: any[]) => {
      this.BoothType = res;
      if (this.BoothType.length === 0) {
        this.mrktReportForm.controls['BoothTypeId'].setValue('');
      } else {
        this.mrktReportForm.controls['BoothTypeId'].setValue(null);
      }
      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
    this.subscriptions.push(BoothTypeList);
  }

  getASCloudLicenseSettings(): void {
      const licenseSettings = this.generalService.ASLicenseSettings;
      if (licenseSettings !== null) {
        this.noLayout = licenseSettings.NoLayout ?? false;
        return;
      }

      this.generalService.getASCloudLicenseSettings().pipe(take(1)).subscribe({
        next: (res: ASLicenseSettings) => {
          this.generalService.ASLicenseSettings = res;
          this.noLayout = res.NoLayout ?? false;
        },
        error: () => {
          this.noLayout = false;
        }
      });
    }

  getVendorById(): void {
    const vendorId = this.mrktReportForm.get('marketVendorId')?.value;

    if (!vendorId) {
      this.mrktReportForm.patchValue({ vendorName: '', vendorSeqId: '' });
      return;
    }

    this.subscriptions.push(
      this.vendorService.getVendorInfoByMarketVendorId(vendorId)
        .pipe(take(1))
        .subscribe((res) => {
          if (res?.VendorId) {
            this.mrktReportForm.patchValue({
              vendorSeqId: res.VendorId,
              vendorName: res.VendorName,
            });
          }
          else {
            this.mrktReportForm.patchValue({
              vendorSeqId: '',
              vendorName: '',
            });
            this.showWarning($localize`Vendor ID does not exist.`);
          }
        })
    );
  }

  getFiscalYearList(minYear: number, maxYear: number): { id: number; text: string }[] {
    const years: { id: number; text: string }[] = [];

    for (let year = maxYear; year >= minYear; year--) {
      years.push({
        id: year,
        text: `Jan ${year} - Dec ${year}`
      });
    }

    return years;
  }

  private showWarning(message: string) {
    Swal.fire({
      title: $localize`Warning`,
      text: message,
      icon: "warning",
      confirmButtonText: $localize`Ok`,
    });
  }

  getRentalType() {
    this.loaderIcon = Promise.resolve(true);
    this.subscriptions.push(this.marketInfoService.getRentalType().subscribe((res: any) => {
      if (res) {
        console.log(res);
        this.RentaltypeList = res;

        if (this.RentaltypeList != '') {
          this.RentaltypeList.split(',').map((el, i) => {
            switch (el) {
              case '1': this.daily = true;
                break;
              case '2': this.monthly = true;
                break;
              case '3': this.weekly = true;
                break;
              case '4': this.combinedMonthly = true;
                break;
              case '5': this.combinedWeekly = true;
                break;
              case '6': this.quickDaily = true;
                break;
            }
          });
        }
      }
      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    }));
  }

  private setupVendorFilterWatcher(): void {
    const control = this.mrktReportForm.get('DisplayVendorid');

    this.toggleVendorControls(control?.value);

    control?.valueChanges.subscribe(value => {
      this.toggleVendorControls(value);
    });
  }

  private toggleVendorControls(value: string): void {
    const vendorControls = ['marketVendorId', 'vendorName'];

    if (value === '1') {
      vendorControls.forEach(ctrl =>
        this.mrktReportForm.get(ctrl)?.enable()
      );
    } else {
      vendorControls.forEach(ctrl =>
        this.mrktReportForm.get(ctrl)?.disable()
      );
    }
  }

  getOtherCharges() {
    this.loaderIcon = Promise.resolve(true);
    const OtherTypeList = this.otherchargesservice.getOtherCharges().subscribe((res: any) => {

      this.OtherTypeLists = res.sort((a, b) => (a.OtherItem > b.OtherItem) ? 1 : ((b.OtherItem > a.OtherItem) ? -1 : 0));
      //this.mrktReportForm.controls['OtherItemListTypes'].setValue(this.OtherTypeLists[0].OtherItemId)
      //this.marketCount = res.length;

      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
    this.subscriptions.push(OtherTypeList);
  }

  public FAOthercreated(args1) {

    this.othergridData.filterSettings = { mode: 'Immediate', immediateModeDelay: 100 };

  }

  otheritemdataBound(args) {
    Object.assign((<any>this.partgridData.filterModule).filterOperators, { startsWith: 'contains' });
  }

 OtherChargeSelection(
  FAselectbutton: HTMLInputElement,
  FAclearselectbutton: HTMLInputElement
) {
  this.isBulkSelection = true;
  FAselectbutton.checked = true;
  FAclearselectbutton.checked = false;

  this.othergridData.selectionModule.selectRowsByRange(
    0,
    this.OtherTypeLists.length - 1
  );
  this.isBulkSelection = false;
}

OtherChargeClearAllSelection(
  FAclearselectbutton: HTMLInputElement,
  FAselectbutton: HTMLInputElement
) {
  this.isBulkSelection = true;
  FAclearselectbutton.checked = true;
  FAselectbutton.checked = false;

  this.othergridData.clearSelection();
  this.isBulkSelection = false;
}

onOtherGridRowChange() {
  if (this.isBulkSelection) {
    return;
  }
  this.FAselectbutton.nativeElement.checked = false;
  this.FAclearselectbutton.nativeElement.checked = false;
}

  getRevenueCategories() {
    this.loaderIcon = Promise.resolve(true);
    this.subscriptions.push(this.boothtypeservice.GetAllRevenueCategories().subscribe((res: any) => {
      if (res) {
        this.revenueCategoriesList = res.sort((a, b) => (a.RevTxtCode > b.RevTxtCode) ? 1 : ((b.RevTxtCode > a.RevTxtCode) ? -1 : 0));
        this.mrktReportForm.patchValue({
          revenueCategory: this.revenueCategoriesList[0].RevSeqCategoryId
        })
      }
      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    }));
  }

  resetRevenueCategory() {
    this.mrktReportForm.patchValue({
      revenueCategory: this.revenueCategoriesList[0].RevSeqCategoryId
    })
  }

  getParts() {
    this.loaderIcon = Promise.resolve(true);
    this.subscriptions.push(this.layoutService.getParts().subscribe((res: any) => {
      if (res) {
        this.parts = res;
        this.loaderIcon = Promise.resolve(false);
      }
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    }));
  }

  GetMarketDaysSettings() {
    this.subscriptions.push(this.marketInfoService.getMarketDaysSettings().subscribe((response: any) => {
      this.marketDaySettings = response;
      this.selectedMarketDays = [];
      response.Sunday ? this.selectedMarketDays.push(1) : 0;
      response.Monday ? this.selectedMarketDays.push(2) : 0;
      response.Tuesday ? this.selectedMarketDays.push(3) : 0;
      response.Wednesday ? this.selectedMarketDays.push(4) : 0;
      response.Thursday ? this.selectedMarketDays.push(5) : 0;
      response.Friday ? this.selectedMarketDays.push(6) : 0;
      response.Saturday ? this.selectedMarketDays.push(7) : 0;

      var marketDay = new Date();
      if (this.selectedMarketDays.length > 0) {
        while (marketDay != null) {
          for (const el of this.selectedMarketDays) {
            const selectedDayOfWeek = el - 1;
            if (marketDay.getDay() === selectedDayOfWeek) {
              this.mrktReportForm.get('RentalDate').setValue(new Date(marketDay));
              marketDay = null;
              break;
            }
          }
          if (marketDay) {
            marketDay.setDate(marketDay.getDate() + 1);
          }
        }
      }
    }));
  }

  onRenderDayCell(args: RenderDayCellEventArgs): void {
    const day = args.date.getDay();
    switch (day) {
      case 0: // Sunday
        if (!this.marketDaySettings.Sunday) args.isDisabled = true;
        break;
      case 1: // Monday
        if (!this.marketDaySettings.Monday) args.isDisabled = true;
        break;
      case 2: // Tuesday
        if (!this.marketDaySettings.Tuesday) args.isDisabled = true;
        break;
      case 3: // Wednesday
        if (!this.marketDaySettings.Wednesday) args.isDisabled = true;
        break;
      case 4: // Thursday
        if (!this.marketDaySettings.Thursday) args.isDisabled = true;
        break;
      case 5: // Friday
        if (!this.marketDaySettings.Friday) args.isDisabled = true;
        break;
      case 6: // Saturday
        if (!this.marketDaySettings.Saturday) args.isDisabled = true;
        break;
    }
  }

  getUserList() {
    this.subscriptions.push(
      this.userService.getUserList().subscribe((res: any[]) => {
        if (res) {
          this.userList = res || [];
        }
      })
    );
  }

  getPOSTerminals() {
    this.loaderIcon = Promise.resolve(true);
    const terminalsList = this.posOpeningCashDrawerService.getPOSTerminals().subscribe((res: any) => {

       // this.terminalsList = response || [];
         this.terminalsLists = res.sort((a, b) => (a.Name > b.Name) ? 1 : ((b.Name > a.Name) ? -1 : 0));

       this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
    this.subscriptions.push(terminalsList);
  }

terminaldataBound(args) {
    Object.assign((<any>this.terminalgridData.filterModule).filterOperators, { startsWith: 'contains' });
  }


 TerminalSelection(
  Terselectbutton: HTMLInputElement,
  Terclearselectbutton: HTMLInputElement
) {
  this.isBulkSelection = true;
  Terselectbutton.checked = true;
  Terclearselectbutton.checked = false;

  this.terminalgridData.selectionModule.selectRowsByRange(
    0,
    this.terminalsLists.length - 1
  );
  this.isBulkSelection = false;
}

TerminalClearAllSelection(
  Terclearselectbutton: HTMLInputElement,
  Terselectbutton: HTMLInputElement
) {
  this.isBulkSelection = true;
  Terclearselectbutton.checked = true;
  Terselectbutton.checked = false;

  this.terminalgridData.clearSelection();
  this.isBulkSelection = false;
}

onTerminalGridRowChange() {
  if (this.isBulkSelection) {
    return;
  }
  this.Terselectbutton.nativeElement.checked = false;
  this.Terclearselectbutton.nativeElement.checked = false;
}

 GetVendorColumnDescriptions(){
    this.reportsService.getVendorColumnDescriptions()
      .subscribe((data: any[]) => {
        this.vendorColumns1 = data.map(item => ({ VdrTxtVendorColumnDesc: item.VdrTxtVendorColumnDesc, VdrTxtVendorColumnId: item.VdrSeqSerno  }));
        this.allColumns = [...this.vendorColumns1];
      });
  }

  findRecordIndex(dataSource: any[], record: any): number {
    return dataSource.findIndex(item => item.VdrTxtVendorColumnDesc === record.VdrTxtVendorColumnDesc);
  }

  selectedRowIndex1: number | null = 0;
  selectedAllRowIndex1: number | null = 0;
  addToActiveGrid(): void {
      var selectedRecords = this.gridAvailableColumns1.getSelectedRecords() as any[];
      if (this.selectedAllRowIndex1 !== null && selectedRecords.length === 0) {
        this.gridAvailableColumns1.selectRow(this.selectedAllRowIndex1);
        selectedRecords = this.gridAvailableColumns1.getSelectedRecords() as any[];
      }
      if (selectedRecords.length > 0) {
        const selectedIndex = this.findRecordIndex(this.vendorColumns1, selectedRecords[0]);
        this.selectedColumns1 = [...this.selectedColumns1, ...selectedRecords];
        this.vendorColumns1 = this.vendorColumns1.filter(item => !selectedRecords.includes(item));
        this.gridAvailableColumns1.clearSelection();

        if (selectedIndex > 0) {
          this.gridAvailableColumns1.refresh();
          this.selectedAllRowIndex1 = selectedIndex - 1;
        }
      }

  }

  addToAllGrid(): void {
      var selectedRecords = this.gridSelectedColumns1.getSelectedRecords() as any[];
      if (this.selectedRowIndex1 !== null && selectedRecords.length === 0) {
        this.gridSelectedColumns1.selectRow(this.selectedRowIndex1);
        selectedRecords = this.gridSelectedColumns1.getSelectedRecords() as any[];
      }
      if (selectedRecords.length > 0) {
        const selectedIndex = this.findRecordIndex(this.selectedColumns1, selectedRecords[0]);
        this.vendorColumns1 = this.vendorColumns1.filter(item => !selectedRecords.includes(item));
        this.selectedColumns1 = this.selectedColumns1.filter(item => !selectedRecords.includes(item));

        selectedRecords.forEach(record => {
          const originalIndex = this.allColumns.findIndex(col => col.VdrTxtVendorColumnDesc === record.VdrTxtVendorColumnDesc);
          if (originalIndex >= 0) {
            this.vendorColumns1.splice(originalIndex, 0, record);
          }
        });

        if (selectedIndex > 0) {
          this.gridSelectedColumns1.refresh();
          this.selectedRowIndex1 = selectedIndex - 1;
        }
      }
    }

}



